import { mergeMap, map, catchError, switchMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as AuthActions from '../actions/auth.actions';
import { AuthService } from './../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import { UserService } from './../../shared/services/user.service';
import { SessionService } from './../../shared/services/session.service';

@Injectable()
export class AuthEffects {
  get$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.getUserRequest),
      mergeMap(() =>
        this.sessionService.getCurrentUserDetails().pipe(
          tap((details) => {
            details.user.fullName =
              details.user?.name + ' ' + details.user?.surname;

            // The NestJS API returns role names on the user; fall back to the
            // `roles` claim on the JWT.
            details.user.roleNames =
              details.user?.roles ?? this.authService.getFromJWT('roles');
          }),
          map((details) => AuthActions.getUserSuccess({ user: details.user })),
          catchError((error) => of(AuthActions.getUserFailed({ error })))
        )
      )
      // mergeMap(() =>
      //   this.userService
      //     .getCurrentUserDetails()
      //     .pipe(map((user: User) => AuthActions.getUserSuccess({ user })))
      // )
    )
  );

  getStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loginStatusRequest),
      map(() =>
        AuthActions.loginStatusSuccess({
          isLoggedIn: this.authService.isLoggedIn(),
        })
      )
    )
  );
  // getStatus$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(AuthActions.selectGetStatus),
  //     mergeMap(() =>
  //       this.authService.login(creds[0], creds[1]).pipe(
  //         map((response: ApiResponse) => AuthActions.loginSuccess({ user: response.result })),
  //         catchError((err) => of(AuthActions.loginFailed({ error: err.message })))
  //       )
  //     )
  //   )
  // );

  loginRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loginRequest, AuthActions.loginPageLoginRequest),
      mergeMap(({ creds }) =>
        this.authService.login(creds[0], creds[1]).pipe(
          // The login result carries the token + user; setSession (in
          // loginSuccess$) reads the token, and the subsequent getUserRequest
          // replaces state with the full user profile from /auth/session.
          map((result) => AuthActions.loginSuccess({ user: result as any })),
          catchError((error) => of(AuthActions.loginFailed({ error })))
        )
      )
    )
  );

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.loginSuccess),
        tap((response) => {
          // `user` here is the login result (token + profile); see loginRequest$.
          const result = response.user as any;
          this.authService.setSession(result);
          // Migrated users on the shared temp password must change it first.
          this.authService.setMustChangePassword(!!result.mustChangePassword);
          this.router.navigateByUrl(
            result.mustChangePassword ? '/change-password' : '/customer'
          );
        })
      ),
    { dispatch: false }
  );

  logoutRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logoutRequest, AuthActions.loginPageLogoutRequest),
      switchMap(() => {
        this.authService.logout();
        return of(AuthActions.logoutSuccess());
      }),
      catchError((error) => of(AuthActions.logoutFailed({ error })))
    )
  );

  logoutSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.logoutSuccess),
        tap(() => {
          this.router.navigateByUrl('/login');
        })
      ),
    { dispatch: false }
  );

  // @Effect({ dispatch: false })
  // LogInSuccess: Observable<any> = this.actions.pipe(
  //   ofType(AuthActionTypes.LOGIN_SUCCESS),
  //   tap((user) => {
  //     localStorage.setItem('token', user.payload.token);
  //     this.router.navigateByUrl('/');
  //   })
  // );

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private sessionService: SessionService,
    private store: Store<IAppState>,
    private actions$: Actions,
    private router: Router
  ) {}
}
